// extracted by mini-css-extract-plugin
export var container = "_67-0";
export var fallback = "_67-5";
export var fallbackIcon = "_67-6";
export var hidden = "_67-2";
export var image = "_67-3";
export var loaded = "_67-4";
export var placeholder = "_67-1";